import { useState, useCallback, useMemo, useEffect } from 'react';
import { useNavigate} from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService.jsx';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import SeccionPageHeader from '../../Utils/SeccionPageHeader.jsx';
import CargandoSpinner from '../../Utils/CargandoSpinner.jsx';
import Modal from 'react-bootstrap/Modal';
import { Row, Col, InputGroup, Card, Button } from 'react-bootstrap';
registerLocale('es', es);
setDefaultLocale('es');

export default function Psicosociales(){
    const navigate = useNavigate();
    const [ Cargando, setCargando] = useState(false);
    const { token, user, rol } = useAuth();
    const [ datos, setDatos] = useState([]);
    const [ swalProps, setSwalProps] = useState({});
    const [estadoAtencion, setEstadoAtencion] = useState(null);
    const [cantidadPersonas, setCantidadPersonas] = useState(0);
    const minDate = new Date(2020, 0, 1);
    const maxDate = new Date(); // Today
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [usrEsLider, setUsrEsLider] = useState(false);
    const [profesionales, setProfesionales] = useState([]);
    const [atencionesPsicosocialesDesenlazadas, setAtencionesPsicosocialesDesenlazadas] = useState([]);
    const [idDerivacionEnlazar, setIdDerivacionEnlazar] = useState(null);
    const [profesionalSeleccionado, setProfesionalSeleccionado] = useState('');
    const [filters, setFilters] = useState({
        id: '',
        com_comuna: '',
        det_fecha: '',
        det_idpersona: '',
        nombre: '',
        det_observaciones: '',
        det_sede: '',
        usuario: '',
        gru_idcabezafamilia: '',
        ate_detallederivacionid: '',
    });
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function consultar(tipoConsulta, estadoAtencion) {
            setCargando(true);
            let url = '';
            setEstadoAtencion(estadoAtencion);
            switch (tipoConsulta) {
                case 'derivaciones':
                    url = '/reparacion/consultarpsicosocialesderivaciones';
                    break;
                case 'atenciones':
                    url = '/reparacion/consultarpsicosocialesatenciones';
                    break;
                default:
                    setCargando(false);
                    return;
            }
            const obj = {
                fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
                fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null,
                estadoAtencion: estadoAtencion || null,
                usrId: user,
            };
            try {
                const response = await apiService.post(url, obj, token);
                if (response.status === 200) {
                    setDatos(response.data.atenciones)
                    setCantidadPersonas(response.data.cantidadPersonas)
                    setUsrEsLider(response.data.esLider)
                    setProfesionales(response.data.profesionales || [])
                } else {
                    setDatos([]);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                setDatos([]);
            } finally {
                setCargando(false);
            }
        };
    const DescargarArchivo = async (filename) => {
            if (!filename) return;
            setCargando(true);
                    
            try {
                const response = await apiService.getFile('/reparacion/descargararchivo', { nombreArchivo: filename }, token);
                if(response.status === 200){
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `${filename}`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
            } catch (err) {
                Mensaje('Descargar archivo', `Hubo un error al descargar el archivo ${filename}: ${err}`);
            } finally {
                setCargando(false);
            }
        };
     
    async function AsignarAtencion(idDetalleAtencion, idProfesional) {
        if (!idProfesional) {
            Mensaje('Asignar atención', 'Por favor, seleccione un profesional para asignar la atención.');
            return;
        }
        setCargando(true);
        try {
            const obj = {
                idDetalleAtencion: idDetalleAtencion,
                idProfesional: idProfesional,
                idUsuario: user,
            }
            const response = await apiService.post(`/reparacion/asignarderivacion`, obj, token);
            if (response.status === 200) {
                Mensaje('Asignar atención', 'Atención asignada exitosamente');
                // Refrescar la lista de atenciones después de asignar
                await consultar('derivaciones');
            } else {
                Mensaje('Asignar atención', 'Hubo un error al asignar la atención');
            }
        } catch (error) {
            console.error('Error assigning attention:', error);
            Mensaje('Asignar atención', 'Hubo un error al asignar la atención');
        } finally {
            setCargando(false);
        }
    }
    
    const filteredDatos = useMemo(() => {
        return datos.filter(row => {
            return Object.keys(filters).every(key => {
                if (!filters[key]) return true;
                const cellValue = String(row[key] || '').toLowerCase();
                return cellValue.includes(String(filters[key]).toLowerCase());
            });
        });
    }, [datos, filters]);
    
    const handleFilterChange = useCallback((field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    }, []);
    
    useEffect(() => {
        function ListarProfesionalesPsicosociales() {
            if(profesionales.length > 0) return;
            apiService.get('/reparacion/listarprofesionalespsicosocial', token)
                .then(response => {
                    if (response.status === 200) {
                        setProfesionales(response.data);
                    } else {
                        setProfesionales([]);
                    }
                })
                .catch(error => {
                    console.error('Error fetching professionals:', error);
                    setProfesionales([]);
                });
        }
        ListarProfesionalesPsicosociales();
    }, [profesionales, token, setProfesionales]);

    async function handleEnlazarAPI(id, idCabezaFamilia) {
        try {
            setCargando(true);            
            const response = await apiService.post(`/reparacion/listaratencionespsicosociales`,
                { idCabezaFamilia }, token);
            if (response.status === 200) {
                setAtencionesPsicosocialesDesenlazadas(response.data.atenciones || []);
                setIdDerivacionEnlazar(id);
                handleShow();
            } else {
                Mensaje('Enlazar API', 'Hubo un error al enlazar');
            }
        } catch (error) {
            console.error('Error enlazando API:', error);
            Mensaje('Enlazar API', 'Hubo un error al enlazar');
        } finally {
            setCargando(false);
        }
    }

    async function EnlazarAtencion(idAtencion) {
        try {
            setCargando(true);
            const response = await apiService.post(`/reparacion/enlazaratencionpsicosocial`,
                { idAtencion, idDerivacion: idDerivacionEnlazar }, token);
            if (response.status === 200) {
                Mensaje('Enlazar Atención', 'Atención enlazada correctamente');
                setIdDerivacionEnlazar(null);
                handleClose();
            } else {
                Mensaje('Enlazar Atención', 'Hubo un error al enlazar la atención');
            }
        } catch (error) {
            console.error('Error enlazando atención:', error);
            Mensaje('Enlazar Atención', 'Hubo un error al enlazar la atención');
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Psicosociales" idCabezaFamilia="0" url={`/`} nombreurl="Inicio" nombreform="Psicosociales" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <Row>
                        <Col md={12} className="mb-3">

                            <Card>
                                <Card.Header>
                                    <h5 className="mb-0">Consultar</h5>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="mb-12" style={{ padding: '10px', display: 'flex', alignItems: 'center' }}>
                                        <Col md={3}>
                                            <InputGroup>
                                            <InputGroup.Text>Fecha inicio</InputGroup.Text>
                                            <DatePicker
                                                selected={fechaInicio}
                                                onChange={date => setFechaInicio(date)}
                                                minDate={minDate}
                                                maxDate={fechaFin || maxDate}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                placeholderText="Seleccione fecha inicio"
                                            />
                                            </InputGroup>
                                        </Col>
                                        <Col md={3}>
                                            <InputGroup>
                                            <InputGroup.Text>Fecha fin</InputGroup.Text>
                                            <DatePicker
                                                selected={fechaFin}
                                                onChange={date => setFechaFin(date)}
                                                minDate={fechaInicio || minDate}
                                                maxDate={maxDate}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                placeholderText="Seleccione fecha fin"
                                            />
                                            </InputGroup>
                                        </Col>
                                        <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button variant="primary" onClick={() => consultar('derivaciones')} className="mb-2 me-2">
                                                Derivaciones pendientes
                                            </Button>
                                            <Button variant="primary" onClick={() => consultar('atenciones', 'ABIERTA')} className="mb-2 me-2">
                                                Atenciones abiertas
                                            </Button>
                                            <Button variant="primary" onClick={() => consultar('atenciones', 'CERRADA')} className="mb-2 me-2">
                                                Atenciones cerradas
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Card>
                                <Card.Header>
                                    <h3 className="card-title">Lista atenciones consultadas - {estadoAtencion ?? 'DERIVACIONES'} - {cantidadPersonas} personas</h3>
                                </Card.Header>
                                <Card.Body>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover table-sm">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Comuna</th>
                                                    <th>Fecha</th>
                                                    <th>Id persona</th>
                                                    <th>Nombre persona</th>
                                                    <th>Observaciones</th>
                                                    <th>Sede</th>
                                                    <th>Nombre usuario</th>
                                                    <th>Id Cabeza familia</th>
                                                    <th>Id Atenci&oacute;n</th>
                                                    <th>Archivo</th>
                                                    <th>Acciones</th>
                                                    <th>Asignaciones</th>
                                                </tr>
                                                <tr style={{ backgroundColor: '#f5f5f5' }}>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar ID"
                                                            value={filters.id}
                                                            onChange={(e) => handleFilterChange('id', e.target.value)}
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar Comuna"
                                                            value={filters.com_comuna}
                                                            onChange={(e) => handleFilterChange('com_comuna', e.target.value)}
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar Fecha"
                                                            value={filters.det_fecha}
                                                            onChange={(e) => handleFilterChange('det_fecha', e.target.value)}
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar ID Persona"
                                                            value={filters.det_idpersona}
                                                            onChange={(e) => handleFilterChange('det_idpersona', e.target.value)}
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar Nombre"
                                                            value={filters.nombre}
                                                            onChange={(e) => handleFilterChange('nombre', e.target.value)}
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar Observaciones"
                                                            value={filters.det_observaciones}
                                                            onChange={(e) => handleFilterChange('det_observaciones', e.target.value)}
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar Sede"
                                                            value={filters.det_sede}
                                                            onChange={(e) => handleFilterChange('det_sede', e.target.value)}
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar Usuario"
                                                            value={filters.usuario}
                                                            onChange={(e) => handleFilterChange('usuario', e.target.value)}
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar ID Cabeza"
                                                            value={filters.gru_idcabezafamilia}
                                                            onChange={(e) => handleFilterChange('gru_idcabezafamilia', e.target.value)}
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Filtrar ID Atención"
                                                            value={filters.ate_detallederivacionid}
                                                            onChange={(e) => handleFilterChange('ate_detallederivacionid', e.target.value)}
                                                        />
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredDatos && filteredDatos.length > 0 ? (
                                                    filteredDatos.map((row) => (
                                                        <tr key={row.id}>
                                                            <td>{row.id}</td>
                                                            <td>{row.com_comuna}</td>
                                                            <td>{row.det_fecha}</td>
                                                            <td>{row.det_idpersona}</td>
                                                            <td>{row.nombre}</td>
                                                            <td>{row.det_observaciones}</td>
                                                            <td>{row.det_sede}</td>
                                                            <td>{row.usuario}</td>
                                                            <td>{row.gru_idcabezafamilia}</td>
                                                            <td>{row.ate_detallederivacionid}</td>
                                                            <td>
                                                                {row.archivoatencion ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link p-0"
                                                                        onClick={(e) => { e.stopPropagation(); DescargarArchivo(row.archivoatencion); }}
                                                                        aria-label={`Descargar ${row.archivoatencion}`}
                                                                    >
                                                                        {row.archivoatencion}
                                                                    </button>
                                                                ) : (
                                                                    'No hay archivo'
                                                                )}
                                                            </td>
                                                            <td>
                                                                {(() => {
                                                                    if (row.ate_detallederivacionid) {
                                                                        if (row.ate_atencioncerrada) {
                                                                            return <span style={{ color: "green", fontWeight: "bold" }}>Atendida</span>;
                                                                        } else {
                                                                            return (
                                                                                <Button 
                                                                                    variant="primary" 
                                                                                    style={{ color: "#000", fontWeight: "bold" }}
                                                                                    onClick={() => navigate(`/caracterizacion/psicosocial/${row.det_idpersona}/${row.ate_detallederivacionid}`)}
                                                                                >
                                                                                    Nueva atenci&oacute;n
                                                                                </Button>
                                                                            );
                                                                        }
                                                                    } else {
                                                                        return (
                                                                            <Button 
                                                                                variant="primary" 
                                                                                style={{ color: "#000", fontWeight: "bold" }}
                                                                                onClick={() => navigate(`/caracterizacion/psicosocial/${row.det_idpersona}/${row.id}`)}
                                                                            >
                                                                                Atender
                                                                            </Button>
                                                                        );
                                                                    }
                                                                })()}
                                                                {rol == '2' && (
                                                                    <Button 
                                                                        variant="secondary" 
                                                                        style={{ color: "#000", fontWeight: "bold" }}
                                                                        onClick={() => handleEnlazarAPI(row.id, row.gru_idcabezafamilia)}
                                                                    >
                                                                        Enlazar API
                                                                    </Button>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {(() => {
                                                                    if (!row.profesionalasignado && usrEsLider) {
                                                                        return (
                                                                            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                                                                                <select 
                                                                                    className="form-select form-select-sm" 
                                                                                    defaultValue="" 
                                                                                    onChange={(e) => setProfesionalSeleccionado(e.target.value)}
                                                                                    style={{ flex: 1, minWidth: '150px' }}>
                                                                                    <option value="">Asignar a...</option>
                                                                                    {profesionales.map(prof => (
                                                                                        <option key={prof.id} value={prof.id}>{prof.usrNombre}</option>
                                                                                    ))}
                                                                                </select>
                                                                                <Button    
                                                                                    variant="secondary"
                                                                                    size="sm"
                                                                                    onClick={() => AsignarAtencion(row.id, profesionalSeleccionado)}
                                                                                >
                                                                                    Asignar
                                                                                </Button>
                                                                            </div>
                                                                        );
                                                                    }else if (row.profesionalasignado) {
                                                                        return <span style={{ color: "blue", fontWeight: "bold" }}>{row.profesionalasignado}</span>;
                                                                    }
                                                                })()}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={7} style={{ textAlign: "center" }}>No hay registros</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <Modal
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                    <Modal.Title>Enlazar atenci&oacute;n</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <div className='table-responsive'>
                        <table className="table table-bordered table-hover table-sm">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>id</th>
                                    <th>idpersona</th>
                                    <th>observaciones</th>
                                    <th>fecha</th>
                                </tr>
                            </thead>
                            <tbody>
                                {atencionesPsicosocialesDesenlazadas.map((item) => (
                                    <tr key={item.id}>
                                        <td><button className="btn btn-primary" onClick={() => EnlazarAtencion(item.id)}>Enlazar</button></td>
                                        <td>{item.id}</td>
                                        <td>{item.idpersona}</td>
                                        <td>{item.observaciones}</td>
                                        <td>{item.fecha.split('T')[0]}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                    </Modal.Footer>
                </Modal>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}